import * as React from 'react';
import { TextAreaWithSave, TextAreaWithSaveProps } from '../../inputs/TextAreaWithSave';
import { FormField, formFieldValidationHelper } from '../FormField';

type TextAreaSaveFieldProps = Omit<TextAreaWithSaveProps, 'onSave' | 'inErrorState'> & {
    label: string,
    infoMessage?: string,
    errorMessage?: string,
    tooltip?: React.ReactNode,
    validator?: (currentValue: string) => { valid: true; } | { valid: false, errorMessage: string; },
    onSave: (value: string, isValid: boolean) => void,
    onSaveNoChange?: () => void;
};

export function TextAreaSaveField (props: TextAreaSaveFieldProps)
{
    const [currentValue, setCurrentValue] = React.useState(props.value);

    function handleChange (value: string)
    {
        setCurrentValue(value);
        if (props.onChange)
        {
            props.onChange(value);
        }
    }

    function handleCancel (cancelledValue: string, restoredValue: string)
    {
        setCurrentValue(restoredValue);
        if (props.onCancel)
        {
            props.onCancel(cancelledValue, restoredValue);
        }
    }

    function handleSave (newValue: string)
    {
        setCurrentValue(newValue);
        props.onSave(newValue, !inErrorState);
    }

    const { inErrorState, message } = formFieldValidationHelper(currentValue, props.infoMessage, props.errorMessage, props.validator);

    return (
        <FormField
            toolTip={props.tooltip}
            label={props.label}
            inputComponent={
                <TextAreaWithSave
                    {...props}
                    value={props.value}
                    onChange={handleChange}
                    onCancel={handleCancel}
                    onSave={handleSave}
                    onSaveNoChange={props.onSaveNoChange}
                    inErrorState={inErrorState}
                />
            }
            inErrorState={inErrorState}
            message={message}
            reserveMessageSpace={true}
        />
    );
}